export default {
    /**
     *
     * @param state
     * @param data {Session}
     */
    setSession(state, data) {
        state.session = data;
    },
    setView(state, view){
        state.view = view;
    },
    setSocket(state, socket) {
        state.socket = socket;
    },
    setReconnectTimeout(state, value) {
        state.reconnectTimeout = value;
    },
    setTokenFetching(state, value) {
        state.tokenFetching = value;
    },
    setClient(state, client) {
        state.client = client;
    },
    setMode(state, mode) {
        state.mode = mode;
    }
}